export const routePath = {
    WorkFlow: 'WorkFlow',
    Dashboard: 'Dashboard',
    pendingApproval: "Pending Approval",
    fileMasterData: "File Master Data",
    duplicate: "Duplicate",
    sapXMLPayload: "sapXMLPayload",
    initiateDocument: "Creator Documents",
    paymentInitiateDocument: "Initiate Payment",
    Approvals: 'Approvals',
    Exception: 'Exception',
    Reports: 'Reports',
    curbayTable: 'Curebay Table',
    Onboarding: 'Onboarding',
    Approved: 'Approved',
    Rejected: 'Rejected',
    addWord: 'Add Word',
    Users: 'Users',
    Permissions: 'Permissions',
    Form: 'Form',
    TaxCodes: 'Tax Codes',
    CostCenter: 'Cost Center',
    ForeignBankMaster: 'Foreign Bank Master',
    foreignDocumentUpload: 'Document Upload',
    foreignAdminTools: 'Foreign Admin Tools',
    emergingRegion: 'Emerging Region',
    PrFiUserMapping: 'PR FI User Mapping',
}